import axios from "axios";

export function getQxByQid() {
  return axios({
    url: "/api/getQxByQid",
    method: "post",
  });
}

export function selectqid(params) {
  return axios({
    url: "/api/selectqid",
    method: "post",
    data: params,
  });
}

export function delQx(params) {
  return axios({
    url: "/api/delQx",
    method: "post",
    data: params,
  });
}

export function addQx(params) {
  return axios({
    url: "/api/addQx",
    method: "post",
    data: params,
  });
}

export function updateQx(params) {
  return axios({
    url: "/api/updateQx",
    method: "post",
    data: params,
  });
}

export function searchUser(params) {
  return axios({
    url: "/api/searchUser",
    method: "post",
    data: params,
  });
}
export function addUser(params) {
  return axios({
    url: "/api/addUser",
    method: "post",
    data: params,
  });
}
export function updateUser(params) {
  return axios({
    url: "/api/updateUser",
    method: "post",
    data: params,
  });
}

export function delUser(params) {
  return axios({
    url: "/api/delUser",
    method: "post",
    data: params,
  });
}

export function selectJs(params) {
  return axios({
    url: "/api/selectJs",
    method: "post",
    data: params,
  });
}

export function deleteRole(params) {
  return axios({
    url: "/api/deleteRole",
    method: "post",
    data: params,
  });
}